
import { defineComponent,onMounted,reactive,ref,toRefs,getCurrentInstance, watch, nextTick} from 'vue'
import {useStore} from 'vuex'
export default defineComponent({
  setup(){
    const {proxy,appContext}= getCurrentInstance() as any
    const store:any =useStore()
    const state:any=reactive({
       showToTop:false,
    })
    const methods:any=reactive({
      listenerScroll:()=>{
        let dom:any=document.getElementsByClassName('helpOut')
        let scrollTop=document.documentElement.scrollTop || document.body.scrollTop||dom[0].scrollTop
        if(scrollTop>50){
          state.showToTop=true
        }else{
          state.showToTop=false
        }
      },
      handleToTop:()=>{
        let dom:any=document.getElementsByClassName('helpOut')[0]
        dom.scrollTop=0
      }
    })
    onMounted(()=>{
      setTimeout(() => {
        let dom:any=document.getElementsByClassName('helpOut')
        dom[0]?.addEventListener('scroll',methods.listenerScroll,true)
      }, 1000);
    })
    watch(()=>store.state.searchTop,(val:any)=>{
      if(val>50){
        state.showToTop=true
      }else{
        state.showToTop=false
      }
    })
    return{
      ...toRefs(state),
      ...toRefs(methods),
    }
  }
})
  /* scrollTop */
